<template>
  <div class="check-in-signature">
    <div class="check-in-signature__canvas"><canvas ref="canvas" aria-label="Signature area" @pointerdown="start" @pointermove="draw" @pointerup="stop" @pointercancel="stop" @pointerleave="stop"></canvas></div>
    <button type="button" class="btn btn--default" @click="clear">Clear signature</button>
  </div>
</template>

<script>
export default {
  name: "SignaturePadComponent",
  emits: ["change"],
  data: () => ({ context: null, drawing: false, hasInk: false }),
  mounted() {
    const canvas = this.$refs.canvas;
    const ratio = window.devicePixelRatio || 1;
    canvas.width = Math.max(1, Math.floor(canvas.clientWidth * ratio));
    canvas.height = Math.max(1, Math.floor(canvas.clientHeight * ratio));
    this.context = canvas.getContext("2d");
    this.context.scale(ratio, ratio);
    this.context.lineWidth = 2;
    this.context.lineCap = "round";
    this.context.strokeStyle = "#172e48";
  },
  methods: {
    point(event) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      return [event.clientX - rect.left, event.clientY - rect.top];
    },
    start(event) {
      event.preventDefault();
      this.drawing = true;
      const [x, y] = this.point(event);
      this.context.beginPath();
      this.context.moveTo(x, y);
      this.$refs.canvas.setPointerCapture(event.pointerId);
    },
    draw(event) {
      if (!this.drawing) return;
      event.preventDefault();
      const [x, y] = this.point(event);
      this.context.lineTo(x, y);
      this.context.stroke();
      if (!this.hasInk) { this.hasInk = true; this.$emit("change", true); }
    },
    stop() { this.drawing = false; },
    clear() {
      const canvas = this.$refs.canvas;
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      this.hasInk = false;
      this.$emit("change", false);
    },
    image() {
      if (!this.hasInk) return null;
      const data = this.$refs.canvas.toDataURL("image/png").split(",")[1];
      if (data.length * 0.75 > 512 * 1024) throw new Error("Signature is too large. Please clear and sign again.");
      return { contentType: "image/png", data };
    },
  },
};
</script>
